<template>
  <div className="row">
    <div className="col">
      <div className="row">
        <div className="col-lg-3 lbl">
          <label>Du:</label>
        </div>
        <div className="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateDu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
    <div className="col">
      <div className="row">
        <div className="col-lg-3 lbl">
          <label>Au:</label>
        </div>
        <div className="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateAu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheServicesUrgence",
  emits: ['imprimer'],
  components: {
    CustomInputDate
  },
  data() {
    return {
      dateDu: null,
      dateAu: null,
      criteresRecherche: {}
    };
  },
  mounted() {
    this.dateDefault();
  },
  methods: {
    dateDefault() {
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 30));
      this.dateAu = this.$commun.formatDate(new Date());
    },
    getCriteresRecherche() {
      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.criteresRecherche.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.criteresRecherche.dateDu = new Date(this.dateDu);
      }
      return this.criteresRecherche;
    }
  }

}
</script>